<template>
  <div v-cloak class="dropdown relative">
    <div
      class="dropdown-trigger"
      @click.prevent="isOpen = !isOpen"
      aria-haspopup="true"
      :aria-expanded="isOpen"
    >
      <slot name="trigger"></slot>
    </div>

    <transition name="pop-out-quick">
      <div class="dropdown-menu" v-show="isOpen" :class="classes">
        <!-- <div class="dropdown-inner"> -->
        <img
          @click.prevent="isOpen = false"
          class="close-x"
          src="/img/icons/close.svg"
        />
        <ul>
          <slot></slot>
        </ul>
        <!-- </div> -->
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["classes"],
  data() {
    return {
      isOpen: false,
    };
  },
  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeIfClickedOutside);
      }
    },
  },
  methods: {
    closeIfClickedOutside(event) {
      if (!event.target.closest(".dropdown")) {
        this.isOpen = false;
        document.removeEventListener("click", this.closeIfClickedOutside);
      }
    },
  },
};
</script>

<style>
.dropdown {
  position: relative;
}
.dropdown-menu {
  position: absolute;
  background-color: #0e5c84;
  padding: 25px;
  color: white;
  top: -10px;
  right: -10px;
  border-radius: 10px;
  z-index: 99;
}

.dropdown-menu .close-x {
  position: absolute;
  top: 10px;
  right: 10px;
}

.dropdown-menu li {
  padding-left: 10px;
  padding-right: 40px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.dropdown-menu li img{
  margin-right: 5px;
}

.dropdown-menu li:last-of-type {
  margin-bottom: 0;
}

.dropdown-menu a {
  color: white;
}

.pop-out-quick-enter-active,
.pop-out-quick-leave-active {
  transition: all 0.4s;
}
.pop-out-quick-enter,
.pop-out-quick-leave-active {
  opacity: 0;
}
</style>